import { SurveyAnswer } from "./survey-answer.model";

export class SurveyAnswerRequest {
  public answers: SurveyAnswer[];
}
